module.exports = "<app-header></app-header>\n<div class=\"container\">\n  <!-- <ng-content></ng-content> -->\n  <router-outlet></router-outlet>\n</div>"